import Vue from "vue";
import App from "./App.vue";
import store from "./store/index"
import router from "./router"
import axios from './api'
import './plugins/element.js'
import './plugins/animate.js'
import './plugins/VueAwesomeSwiper.js'
import './plugins/commonEvent.js'
import './permission.js'
// require styles
import 'normalize.css/normalize.css'
import '@/style/custom-animtetion.scss'
import '@/style/global.scss'
import i18n from './i18n/index'

//全局注册iconFont
// import './plugins/iconfont';
import svgIcon from './components/svgIcon'
Vue.component('svgIcon', svgIcon)
const req = require.context('./icons/svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
import filters from './filter' // global filters
// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false;
Vue.prototype.$api = axios;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
